import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const ssoAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: `${AppConfig.SSO_BASE_URL}/api/v2`,
});

setupInterceptors(ssoAxiosInstance);

export default ssoAxiosInstance;
